import { Dialog } from "@workspace/frontend-ui";
import MobileDialogContent from "./MobileDialogContent";

type Props = {
  onClose: () => void;
};

const MobileDialog: FC<Props> = ({ onClose, children }) => (
  <Dialog open onOpenChange={onClose}>
    <MobileDialogContent>{children}</MobileDialogContent>
  </Dialog>
);

export default MobileDialog;
